export const MS_UNTIL_QUERY_CALL = 500;